<section class="casto-card">
  <header class="header">
    <span class="casto-title large" [innerHTML]="titleKey | translate"></span>
  </header>

  <div class="content">
    <div class="search-bar">
      <input
        type="text"
        pInputText
        [placeholder]="'tunnel.purchase-list.search-placeholder' | translate"
        [value]="searchValue()"
        (input)="onSearchInput($any($event.target).value)" />
    </div>

    <div class="tunnel-product-list-wrapper">
      <ng-casto-tunnel-product-list
        [products]="searchProducts()"
        [loading]="searchLoading()"
        [emptyMessageKey]="emptyMessageKey()">
      </ng-casto-tunnel-product-list>
    </div>

    @if (isSearching() && totalResults() > pageSize) {
      <p-paginator
        [first]="firstResultIndex()"
        [rows]="pageSize"
        [pageLinkSize]="3"
        [totalRecords]="totalResults()"
        (onPageChange)="onPageChange($event)" />
    }
  </div>
</section>
